import { z } from "zod";

import { LocationMapSchema } from "@widgets/contact-map-card";

import { ColorIconSchema } from "@shared/content-types/schemas/common.schema";
import { DynamicZoneSchema } from "@shared/content-types/schemas/dynamicZone.schema";
import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";

export const EventSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime().optional(),
  title: z.string().min(1),
  widgetLink: z.string().min(1),
  location: z.string().min(1),
  mainColor: z.string().min(1),
  slug: z.string().min(1),
  time: z.string().min(1),
  date: z.string().min(1),
  dateEnd: z.string().min(1).nullable(),
  price: z.number().int().positive(),
  pageIcon: ColorIconSchema,
  programDocuments: StrapiMediaSchema,
  contactMapSection: LocationMapSchema,
  image: StrapiMediaSchema,
  imageForSlider: StrapiMediaSchema,
  content: DynamicZoneSchema,
});
